var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6998 7.80019C11.2455 5.39541 13.3961 3.6002 15.966 3.6002C18.9483 3.6002 21.366 6.01786 21.366 9.00019C21.366 11.7627 19.2916 14.0407 16.6155 14.3615M7.0998 6.0002L9.4998 3.6002L7.0998 1.2002M2.2998 8.40019V6.8002C2.2998 5.03288 3.73249 3.6002 5.4998 3.6002H7.89981M17.8998 18.0002L15.4998 20.4002L17.8998 22.8002M22.6998 15.6002V17.2002C22.6998 18.9675 21.2671 20.4002 19.4998 20.4002H17.0998M13.0998 16.2002C13.0998 19.1825 10.6821 21.6002 7.6998 21.6002C4.71747 21.6002 2.2998 19.1825 2.2998 16.2002C2.2998 13.2179 4.71747 10.8002 7.6998 10.8002C10.6821 10.8002 13.0998 13.2179 13.0998 16.2002Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.6e0d92c00f252a3a9878b1f5798a36a7.svg";
export { ForwardRef as ReactComponent };